var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import { TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import FSButton from '@components/FSButton';
import ModalHeader from '@shared/modal/ModalHeader';
import FSMonthPicker from '@components/FSMonthPicker';
import RangeIndicator from '@shared/input/RangeIndicator';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { useTagContext } from '@data/tag/tagContext';
import { useActiveYears } from '@data/hooks/timePoints';
import { forecastApi, workerJobsApi } from '@data/rest/api';
import { SimpleGrid } from '@styled/Grid';
import { ModalBody, ModalFooterStyled } from '@styled/Modal';
import { FormField, FormFieldErrorHelp, FormFieldLabel } from '@styled/Form';
function isValidInterval(fromMonth, fromYear, toMonth, toYear) {
    return fromYear < toYear || (fromYear === toYear && fromMonth <= toMonth);
}
export function CustomForecastModal(_a) {
    var targetTagIds = _a.targetTagIds, accountTagId = _a.accountTagId, historyRange = _a.historyRange, forecastRange = _a.forecastRange, invalidateModelTable = _a.invalidateModelTable;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var activeYears = useActiveYears();
    var _b = __read(useState({}), 2), validation = _b[0], setValidation = _b[1];
    var _c = __read(useState({
        historyRange: historyRange,
        tagIds: accountTagId !== undefined ? [accountTagId] : [],
    }), 2), forecastData = _c[0], setForecastData = _c[1];
    var tagInfos = forecastData.tagIds.map(function (tid) {
        return {
            id: tid,
            inherited: false,
            originalClusterId: 0,
            originalClusterTitle: '',
        };
    });
    var disabledMonthsByYearStart = useMemo(function () {
        var e_1, _a;
        var disabledMonthsByYear = {};
        try {
            for (var activeYears_1 = __values(activeYears), activeYears_1_1 = activeYears_1.next(); !activeYears_1_1.done; activeYears_1_1 = activeYears_1.next()) {
                var year = activeYears_1_1.value;
                if (year < forecastData.historyRange.to.year) {
                    continue;
                }
                var thisYearDisabledMonths = [];
                for (var month = 1; month <= 12; month++) {
                    if (year > forecastData.historyRange.to.year || month > forecastData.historyRange.to.month) {
                        thisYearDisabledMonths.push(month);
                    }
                }
                disabledMonthsByYear[year] = thisYearDisabledMonths;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (activeYears_1_1 && !activeYears_1_1.done && (_a = activeYears_1.return)) _a.call(activeYears_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return disabledMonthsByYear;
    }, [forecastData.historyRange.to.month, forecastData.historyRange.to.year]);
    var disabledMonthsByYearEnd = useMemo(function () {
        var e_2, _a;
        var disabledMonthsByYear = {};
        var allMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        try {
            for (var activeYears_2 = __values(activeYears), activeYears_2_1 = activeYears_2.next(); !activeYears_2_1.done; activeYears_2_1 = activeYears_2.next()) {
                var year = activeYears_2_1.value;
                if (year > forecastData.historyRange.from.year && year < forecastRange.from.year) {
                    continue;
                }
                if (year < forecastData.historyRange.from.year || year > forecastRange.from.year) {
                    disabledMonthsByYear[year] = __spreadArray([], __read(allMonths), false);
                }
                else {
                    var thisYearDisabledMonths = [];
                    if (year === forecastData.historyRange.from.year) {
                        for (var month = 1; month <= 12; month++) {
                            if (month < forecastData.historyRange.from.month) {
                                thisYearDisabledMonths.push(month);
                            }
                        }
                    }
                    if (year === forecastRange.from.year) {
                        for (var month = 1; month <= 12; month++) {
                            if (month >= forecastRange.from.month) {
                                thisYearDisabledMonths.push(month);
                            }
                        }
                    }
                    disabledMonthsByYear[year] = thisYearDisabledMonths;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (activeYears_2_1 && !activeYears_2_1.done && (_a = activeYears_2.return)) _a.call(activeYears_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return disabledMonthsByYear;
    }, [forecastData.historyRange.from.month, forecastData.historyRange.from.year, forecastRange.from]);
    function validate() {
        var errObj = {};
        // check if historical from is less or equal than historical to
        if (!isValidInterval(forecastData.historyRange.from.month, forecastData.historyRange.from.year, forecastData.historyRange.to.month, forecastData.historyRange.to.year)) {
            errObj.historyRange = L('End date must be greater than start date');
            return errObj;
        }
        // check if forecast start is greater than historical end
        if (forecastData.historyRange.to.year > forecastRange.from.year ||
            (forecastData.historyRange.to.year === forecastRange.from.year &&
                forecastData.historyRange.to.month >= forecastRange.from.month)) {
            errObj.historyRange = L('History data cannot overlap with forecast data');
            return errObj;
        }
        var sourceAccountTagIds = forecastData.tagIds.filter(function (tagId) { var _a; return ((_a = tagData.tagById[tagId]) === null || _a === void 0 ? void 0 : _a.type) === TagType.Account; });
        if (sourceAccountTagIds.length === 0) {
            errObj.tags = L('Please choose an account tag');
            return errObj;
        }
        return undefined;
    }
    function startJob() {
        return __awaiter(this, void 0, void 0, function () {
            var errors, historyRange_1, historyDataExpression, response, response_1, responseBody, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errors = validate();
                        if (!errors) return [3 /*break*/, 1];
                        setValidation(errors);
                        return [3 /*break*/, 10];
                    case 1:
                        setValidation({});
                        startGlobalLoading();
                        historyRange_1 = {
                            from: { month: forecastData.historyRange.from.month, year: forecastData.historyRange.from.year },
                            to: { month: forecastData.historyRange.to.month, year: forecastData.historyRange.to.year },
                        };
                        historyDataExpression = "tags(".concat(forecastData.tagIds.join(','), ")");
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 10]);
                        return [4 /*yield*/, forecastApi.forecast({
                                historyRange: historyRange_1,
                                forecastRange: forecastRange,
                                data: [
                                    {
                                        historyDataExpression: historyDataExpression,
                                        targetRows: targetTagIds,
                                    },
                                ],
                            })];
                    case 3:
                        response = _a.sent();
                        stopGlobalLoading();
                        Manager.closeModal();
                        Manager.renderModal(React.createElement(ForecastProgressModal, { invalidateModelTable: invalidateModelTable }));
                        return [3 /*break*/, 10];
                    case 4:
                        response_1 = _a.sent();
                        stopGlobalLoading();
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 8, , 9]);
                        if (!(typeof response_1.json === 'function')) return [3 /*break*/, 7];
                        return [4 /*yield*/, response_1.json()];
                    case 6:
                        responseBody = _a.sent();
                        if (typeof responseBody.message === 'string') {
                            setValidation({ message: L(responseBody.message) });
                        }
                        else {
                            setValidation({ message: L('Error starting forecast') });
                        }
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_1 = _a.sent();
                        setValidation({ message: L('Error starting forecast') });
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    function addTag(tagId) {
        var _a;
        var forecastDataCopy = __assign({}, forecastData);
        if (((_a = tagData.tagById[tagId]) === null || _a === void 0 ? void 0 : _a.type) === TagType.Account) {
            forecastDataCopy.tagIds = forecastDataCopy.tagIds.filter(function (tId) { var _a; return ((_a = tagData.tagById[tId]) === null || _a === void 0 ? void 0 : _a.type) !== TagType.Account; });
        }
        forecastDataCopy.tagIds.push(tagId);
        setForecastData(forecastDataCopy);
    }
    function removeTag(tagId) {
        var forecastDataCopy = __assign({}, forecastData);
        forecastDataCopy.tagIds = forecastDataCopy.tagIds.filter(function (id) { return id !== tagId; });
        setForecastData(forecastDataCopy);
    }
    return (React.createElement(Modal, { width: "400" },
        React.createElement(ModalHeader, { title: L('Custom Forecast') }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(SimpleGrid, { "$columnNumber": 2 },
                    React.createElement(FormField, null,
                        React.createElement(FormFieldLabel, null, L('Historical Data From')),
                        React.createElement(FSMonthPicker, { selectedMonth: forecastData.historyRange.from.month, selectedYear: forecastData.historyRange.from.year, onChange: function (newMonth, newYear) {
                                return setForecastData(__assign(__assign({}, forecastData), { historyRange: __assign(__assign({}, forecastData.historyRange), { from: {
                                            month: newMonth,
                                            year: newYear,
                                        } }) }));
                            }, years: activeYears, disabledMonthsByYear: disabledMonthsByYearStart })),
                    React.createElement(FormField, null,
                        React.createElement(FormFieldLabel, null, L('Historical Data To')),
                        React.createElement(FSMonthPicker, { selectedMonth: forecastData.historyRange.to.month, selectedYear: forecastData.historyRange.to.year, onChange: function (newMonth, newYear) {
                                return setForecastData(__assign(__assign({}, forecastData), { historyRange: __assign(__assign({}, forecastData.historyRange), { to: {
                                            month: newMonth,
                                            year: newYear,
                                        } }) }));
                            }, years: activeYears, disabledMonthsByYear: disabledMonthsByYearEnd }),
                        validation.historyRange && (React.createElement(FormFieldErrorHelp, null, validation.historyRange))),
                    React.createElement(FormField, { style: { gridColumnStart: 1, gridColumnEnd: 'span 2' } },
                        React.createElement(FormFieldLabel, null, L('Source Variable & Dimensions')),
                        React.createElement(Tags, { tags: tagInfos, select: addTag, remove: removeTag, filterByTypes: [TagType.Account, TagType.Dimension] }),
                        validation.tags && React.createElement(FormFieldErrorHelp, null, validation.tags)))),
            validation.message && (React.createElement(FormFieldErrorHelp, null, "".concat(L('Error'), ": ").concat(validation.message)))),
        React.createElement(ModalFooterStyled, null,
            React.createElement(FSButton, { "$type": "tertiary", title: L('Close'), onClick: Manager.closeModal }),
            React.createElement(FSButton, { title: L('Forecast'), onClick: startJob }))));
}
export function ForecastProgressModal(_a) {
    var invalidateModelTable = _a.invalidateModelTable;
    var L = useLanguage().L;
    var _b = __read(useState(), 2), freshQueueStatus = _b[0], setFreshQueueStatus = _b[1];
    var _c = __read(useState(1), 2), maxQueued = _c[0], setMaxQueued = _c[1];
    function pollQueueStatus() {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedQueueStatus, totalJobs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, workerJobsApi.getQueueStatus()];
                    case 1:
                        fetchedQueueStatus = _a.sent();
                        setFreshQueueStatus(fetchedQueueStatus);
                        totalJobs = fetchedQueueStatus.activeCount + fetchedQueueStatus.queuedCount;
                        if (totalJobs > maxQueued) {
                            setMaxQueued(totalJobs);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        // whenever queue status is updated, set timeout that will get fresh queue status in 2 seconds
        // if there is no queue status, it is the initial render, so poll immediately
        var timeoutId = null;
        if (freshQueueStatus === undefined) {
            pollQueueStatus();
        }
        else {
            timeoutId = setTimeout(pollQueueStatus, 2000);
        }
        return function () {
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }
        };
    }, [freshQueueStatus]);
    var bodyContent = React.createElement("h3", null, L('Loading...'));
    if (freshQueueStatus !== undefined) {
        var freshTotalJobs = freshQueueStatus.activeCount + freshQueueStatus.queuedCount;
        if (freshTotalJobs === 0) {
            bodyContent = React.createElement("h3", null, L('No currently active jobs'));
        }
        else {
            bodyContent = (React.createElement(React.Fragment, null,
                React.createElement("h3", null,
                    L('Active jobs'),
                    ': ',
                    freshQueueStatus.activeCount),
                React.createElement("h3", null,
                    L('Queued jobs'),
                    ': ',
                    freshQueueStatus.queuedCount),
                React.createElement(RangeIndicator, { value: ((maxQueued - freshTotalJobs) / maxQueued) * 100, percentage: true })));
        }
    }
    return (React.createElement(Modal, { width: "600" },
        React.createElement(ModalHeader, { title: L('Forecast Progress') }),
        React.createElement(ModalBody, null, bodyContent),
        React.createElement(ModalFooterStyled, null,
            React.createElement(FSButton, { "$type": "tertiary", title: L('Close'), onClick: function () {
                    // fetch forecast errors (mape and mase)
                    // const forecastErrors = await forecastApi.getErrors();
                    // baobab.root.set(['models', 'forecastErrors'], forecastErrors);
                    invalidateModelTable();
                    Manager.closeModal();
                } }))));
}
